import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { languageApiData } from "../../../../constant/appConstant";
import fetcher from "../../../../dataProvider";
import {
  setCountryList,
  setJourneyText,
  setLoading,
  setSelectedCountry,
  setToastData,
} from "../../../../redux/slices/customerJourney";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { SelectedCountry, stepProps } from "../../../../types/common";
import Select from "../../../common/FormComponents/Select";
import usePageView from "../../../../utils/analytics/usePageView";
import GTM from "../../../../utils/analytics/gtm";

const Location = (props: stepProps) => {
  usePageView("Select Location");
  const dispatch = useAppDispatch();
  const { toggleSteps, stepDataManager } = props;
  const customerJourney = useAppSelector((state) => state.customerJourney);
  const { countryList, pageText } = customerJourney;
  const [listCountry, setListCountry] = useState<any>([]);

  const getLanguageData = async (country: SelectedCountry) => {
    dispatch(setLoading({ loading: true }));
    try {
      let body = {
        ...languageApiData,
        languageCode: "en-GB",
      };
      if (country) {
        body = {
          ...languageApiData,
          alias: country.label,
        };
      }
      const { data } = await fetcher.post("/api/Home", body);
      sessionStorage.setItem(
        "defaultLanguage",
        JSON.stringify(data?.languages)
      );
      sessionStorage.setItem("selectedCountry", JSON.stringify(country));
      dispatch(setJourneyText({ data: data }));
      dispatch(setLoading({ loading: false }));
    } catch (e) {
      console.log("error", e);
      dispatch(setLoading({ loading: false }));
    }
  };

  const getLocationData = async () => {
    try {
      const { data } = await fetcher.get(
        "/api/LookupData/Countries?languageCode=en-GB"
      );
      dispatch(setCountryList({ list: data }));
    } catch (e) {
      console.log("Error ", e);
      dispatch(
        setToastData({
          toastData: {
            message: pageText?.labelsMetadata?.somethingwrong,
            open: true,
            type: "failure",
          },
        })
      );
    }
  };

  useEffect(() => {
    getLocationData();
    stepDataManager();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    const data = countryList.map((item) => {
      return {
        value: item.idValue,
        label: item.textValue,
        isoCode: item.isoCode,
      };
    });
    setListCountry(data);
  }, [countryList]);

  const { control, handleSubmit, formState, setValue, getValues, ...rest } =
    useForm({
      mode: "all",
      defaultValues: {
        location: undefined,
      },
    });

  const { errors } = formState;

  const toggleSubmit = async (values: any) => {
    const country = values.location;
    await getLanguageData(country);
    dispatch(setSelectedCountry({ country }));
    toggleSteps("examDetails", 1);
    GTM.selectCountry(country);
  };

  return (
    <Paper component={Box} p={4} mb={10} mt={8} className="green">
      <Typography mb={1}>
        Select country / territory{" "}
        <Typography color="#EA0034" component="span">
          (required)
        </Typography>
      </Typography>
      <Stack
        component="form"
        onSubmit={handleSubmit(toggleSubmit)}
        gap={{ xs: 2, sm: 6 }}
        direction={{ sm: "row" }}
        justifyContent="space-between"
      >
        <Box className="dropdown" flexGrow={1}>
          <Select
            classNamePrefix={"filter_drop"}
            placeholder={`- ${pageText?.labelsMetadata?.selectText} -`}
            options={listCountry}
            control={control}
            errors={errors}
            name="location"
            rules={{
              required: {
                value: true,
                message: "Please select a country / territory",
              },
            }}
          />
        </Box>
        <Box>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ padding: "12px 40px", mt: { sm: "-5px" } }}
          >
            {pageText?.buttonsMetadata?.nextButtonText}
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
};

export default Location;
